<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">分析统计&gt;</div>
      </div>

      <!--<div class="body_content">
        <div class="workloadStatisticsMenu">
          <router-link v-for="(workloadStatisticsMenu, index) in workloadStatistics_menu" :key="index" :to="{name: workloadStatisticsMenu.routeName}">
            <button type="button" class="btn btn-default workloadStatisticsOptionMenu"
                    :class="{click_workloadStatisticsOptionMenu: workloadStatisticsMenu.url == current_workloadStatistics_menu}"
                    @click="current_workloadStatistics_menu = workloadStatisticsMenu.url">
              {{workloadStatisticsMenu.name}}
            </button>
          </router-link>
        </div>
        <router-view></router-view>
      </div>-->
      <div class="body_content">
        <div class="workTab">
          <router-link to="/classStatistics">
            <button class="btn btn-default workMenu">课时统计</button>
          </router-link>
          <router-link to="/teachingEvaluationAll">
            <button v-if="userCode.indexOf(leaderUserCode) != -1" class="btn btn-default workMenu">教师评估统计</button>
          </router-link>
          <router-link to="/teachingEvaluationOutside">
            <button v-if="userCode.indexOf(leaderUserCode) != -1" class="btn btn-default workMenu">外聘教师评估统计</button>
          </router-link>
          <router-link to="/attendanceTeacher">
            <button class="btn btn-default workMenu">考勤统计</button>
          </router-link>
          <router-link to="/topicFind">
            <button class="btn btn-default workMenu">专题查询</button>
          </router-link>
          <router-link to="/externalTeacherStatistics">
            <button class="btn btn-default workMenu">外聘教师日程</button>
          </router-link>
          <router-link to="/studyTrainingDetailsStatistics" exact>
            <button class="btn btn-default workMenu">学习培训详情统计</button>
          </router-link>
        </div>
        <router-view></router-view>
      </div>
    </div>
  </div>

</template>

<script>
  import {schoolAxios} from '../main';
  import {getContentSize} from './mainView';
  export default {
    name: "workloadStatistics",
    data() {
      return {
        /* current_workloadStatistics_menu : '',
         workloadStatistics_menu : [
           {'routeName': 'StudyTrainingDetailsStatistics','url':'/studyTrainingDetailsStatistics','name':'学习培训详情统计'},
           {'routeName': 'ClassStatistics','url':'/classStatistics','name':'课时统计'},
         ],*/

        //教务领导
        leaderUserCode: this.$store.state.leaderUserCode,
        userCode: this.$store.state.userCode,
        chooseDate:{
          startDate:'',
          endDate:''
        }
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        /* this_.current_workloadStatistics_menu = this_.$route.path;*/
      });
    },
    methods: {
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/workLoadStatistics.css";
</style>



// WEBPACK FOOTER //
// src/components/workloadStatistics.vue